module.exports = __webpack_public_path__ + "static/media/ic_conduite_nacelle_white.6898c3c1.svg";